<h1>Users</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (tab of tabs; track tab) {
    <a mat-tab-link (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
      {{tab.title}}
    </a>
  }
</nav>
@if (activeTab.id === 'detail') {
  <app-superadmin-users-detail></app-superadmin-users-detail>
}
@if (activeTab.id === 'subscription-dunning') {
  <app-superadmin-users-subscription-dunning></app-superadmin-users-subscription-dunning>
}
@if (activeTab.id === 'push') {
  <app-superadmin-users-push></app-superadmin-users-push>
}
@if (activeTab.id === 'blacklist') {
  <app-superadmin-users-blacklist></app-superadmin-users-blacklist>
}
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
